import { ENDPOINTS } from "config/endpoints";
import { useMutation, useQueryClient } from "react-query";
import Error from "types/error";
import client from "utils/client";
import { Request } from "types/request";
import { Response } from "types/response";
import { Contact } from "types/user";
import { generatePath } from "react-router-dom";

interface DeleteFriendshipRequestInfo {
  requestId: string;
}

export default function useDeleteFriendshipRequest() {
  const queryClient = useQueryClient();

  const deleteFriendshipRequest = (data: DeleteFriendshipRequestInfo) => {
    const { requestId } = data;
    const request: Request = {
      url: generatePath(ENDPOINTS.friendshipRequest.delete, { id: requestId }),
      config: {
        method: "patch",
      },
    };
    return client(request);
  };

  const { data, mutate, ...rest } = useMutation<
    Response<Contact>,
    Error,
    DeleteFriendshipRequestInfo
  >(deleteFriendshipRequest, {
    onSettled: (data, error, variables) => {
      queryClient.invalidateQueries([ENDPOINTS.friendshipRequest.sent]);
    },
  });

  return { data, mutate, ...rest };
}
